export default function CategoryTabs({
  categories,
  activeSlug,
  onSelect,
}: {
  categories: { name: string; slug: string }[];
  activeSlug: string;
  onSelect: (slug: string) => void;
}) {
  return (
    <div className="flex items-center flex-wrap gap-2">
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onSelect(cat.slug)}
          className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200 border border-background-200/70'
          }`}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
}